import React from 'react';

import Carousel from 'react-multi-carousel';
import { Link, useNavigate } from 'react-router-dom';
import 'react-multi-carousel/lib/styles.css';
import icn1 from '../assests/img/home-applice.jpg'
import icn2 from '../assests/img/light.jpg'
import icn3 from '../assests/img/tool.jpg'
import icn4 from '../assests/img/michnery.jpg'
import icn5 from '../assests/img/stone.jpg'
import icn6 from '../assests/img/cctv.jpg'


const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 6
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

const CatlogSlider = () => {
  return (
    <div>
      
      <div className="w-full  ">
            <Carousel responsive={responsive}
             infinite={false}>
              
              <div>
              <div className='block m-2 text-center border pt-4 rounded-md'>
           <div className='border text-center flex h-[100px] justify-center  pb-4   border-b-gray-200 border-l-0 border-r-0 border-t-0'> 
           <img src={icn1} alt='Home Appliances'/></div>           
            <h4 className='text-left p-2 text-[14px] text-[#2d3840]'><Link to="/products/home-appliances">Home Appliances</Link></h4>       
             </div>
              </div>

              <div>  <div className='block m-2 text-center border pt-4  rounded-md'>
           <div className='border text-center flex h-[100px] justify-center  pb-4   border-b-gray-200 border-l-0 border-r-0 border-t-0'> 
           <img src={icn2} alt='Lights and Lighting'/></div>
           <h4 className='text-left p-2 text-[14px] text-[#2d3840]'><Link to="/products/lights-and-lighting">Lights and Lighting</Link></h4>                  
             </div></div>

              <div>  <div className='block m-2 text-center border pt-4  rounded-md'>
           <div className='border text-center flex h-[100px] justify-center  pb-4   border-b-gray-200 border-l-0 border-r-0 border-t-0'> 
           <img src={icn3} alt='Machinery and Tools'/></div>      
           <h4 className='text-left p-2 text-[14px] text-[#2d3840]'><Link to="/products/machinery-and-tools">Machinery and Tools</Link></h4>            
             </div></div>

              <div> 
              <div className='block m-2  text-center border pt-4 rounded-md'>
           <div className='border text-center flex h-[100px] justify-center  pb-4   border-b-gray-200 border-l-0 border-r-0 border-t-0'> 
           <img src={icn4} alt='Minerals and Metallurgy'/></div>   
           <h4 className='text-left p-2 text-[14px] text-[#2d3840]'><Link to="/products/minerals-and-metallurgy">Minerals and Metallurgy</Link></h4>              
             </div>
                </div> 

              <div><div className='block m-2 text-center border pt-4 rounded-md'>
           <div className='border text-center flex h-[100px] justify-center  pb-4   border-b-gray-200 border-l-0 border-r-0 border-t-0'> 
           <img src={icn5} alt='Natural Stone'/></div>         
           <h4 className='text-left p-2 text-[14px] text-[#2d3840]'><Link to="/products/natural-stone">Natural Stone</Link></h4>              
             </div></div> 

             <div>
              <div className='block m-2 text-center border pt-4 rounded-md'>
           <div className='border text-center flex h-[100px] justify-center  pb-4   border-b-gray-200 border-l-0 border-r-0 border-t-0'> 
           <img src={icn6} alt='Security and Protection'/></div>           
           <h4 className='text-left p-2 text-[14px] text-[#2d3840]'><Link to="/products/security-and-protection">Security and Protection</Link></h4>       
             </div>
              </div>


            </Carousel>
           
          </div>






    </div>
  )
}

export default CatlogSlider
